import React, { useEffect } from "react";
import "./index.scss";
import { Col, Image, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";

import HowToBid from "@assets/images/how-to-bid.svg";
import { Link } from "react-router-dom";
import { PATHS } from "@config/constants";
import menuIcon from "@assets/images/ldp/menu_icon.png";
import HomeHeader from "@components/HomeHeader";

const { Title, Paragraph } = Typography;
const RulesPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("title.rules");
  }, [t]);

  return (
    <div>
      <HomeHeader tabActive={2} />
      <div className="rules-page">
        <div className="rules-page-wrapper">
          <Row justify="center">
            <Col xs={24}>
              {/*<Title level={2} className="rules-page-title">{t("rules")}</Title>*/}
              <div className="box-text">
                <div className="box-title">{t("rules")}</div>
              </div>

              <div className="rules-page-content">
                <Typography>
                  {/* <Title level={2}>REGLAS</Title> */}
                  {/* <Paragraph>
                      Para poder tener pujas y poder jugar, los usuarios deben de tener una suscripción activa en el Servicio
                    </Paragraph> */}
                  {/* <Title level={2}>Cómo participar:</Title>
                    <Paragraph>
                      <Image
                          width={"100%"}
                          preview={false}
                          src={HowToBid}
                      />
                    </Paragraph> */}
                  <Title level={2}>
                    Condiciones de una puja/oferta válida:
                  </Title>
                  <Paragraph>
                    <ul>
                      <li>
                        El valor de la <b> puja mínima es S/ 0.1</b> y el valor
                        de la <b>puja máxima es S/1000000</b>
                      </li>
                      <li>
                        La moneda S/ usada en el ciclo de subasta es referencial
                        para el juego. La moneda de las pujas no representa al
                        dinero real{" "}
                      </li>
                      <li>
                        Un cliente solo puede colocar una puja/oferta con un{" "}
                        <b>máximo de 1 decimal</b>. Por ejemplo, puedes colocar
                        una puja/oferta por S/ 0.8, pero no puedes colocar una
                        puja/oferta por S/ 0.87.
                      </li>
                      <li>
                        Una puja no equivale a ningún valor en específico. El
                        cliente que tenga una puja podrá colocar esa puja por el
                        producto a subastarse con el valor que considere
                        pertinente, siempre y cuando ese valor a colocar esté
                        comprendido entre los valores detallados previamente
                        (Entre S/ 0.1 y S/1000000).
                      </li>
                      <li>
                        Luego de colocar su oferta/puja, el cliente recibirá un
                        SMS donde se le comunicará si la puja/oferta que realizó
                        fue la más baja y única o si no es la más baja y única.
                      </li>
                    </ul>
                  </Paragraph>

                  <Title level={2}>
                    Condiciones para que una puja/oferta pueda ganar:{" "}
                  </Title>

                  <Paragraph>
                    <ul>
                      <li>
                        Habrá un ganador siempre y cuando haya un cliente que
                        haya colocado una puja/oferta más baja, única y válida
                        (entre los valores detallados en el numeral 4 de los
                        Términos y Condiciones) durante el ciclo de la subasta
                      </li>
                      <li>
                        En caso en el ciclo de la subasta no haya una
                        puja/oferta más baja, única y válida no se declarará un
                        ganador por ese producto. Bitel podrá utilizar dicho
                        producto para próximas subastas
                      </li>
                      <li>
                        Podrá haber máximo un (1) ganador por cada sesión de
                        subasta.
                      </li>
                    </ul>
                  </Paragraph>
                  <Title level={2}>Horario de Subastas: </Title>
                  <Paragraph>
                    La sesión de la subasta inicia cada domingo a las 08:00 a.m.
                    y termina el sábado siguiente a las 02:00 p.m. Los jugadores
                    no pueden participar en la subasta fuera del horario
                    establecido.
                  </Paragraph>
                </Typography>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default RulesPage;
